import { defineComponent as _defineComponent } from 'vue'
import { ref, Ref } from "vue";
import { useApiStore, type Project } from "@/stores/api";


export default /*#__PURE__*/_defineComponent({
  props: {
    exclude: { type: Array, required: false, default: () => [] },
    only: { type: Array, required: false, default: () => [] }
  },
  setup(__props: any, { expose }) {
  expose();

const props = __props as { exclude: number[], only: number[] }

const apiStore = useApiStore();



const projects: Ref<Project[]> = ref([]);

apiStore.getProjects({ exclude: props.exclude, per_page: 2, include: props.only }).then((p: Project[]) => (projects.value = p));

const getColor = (color: "bg-beige-100" | "bg-beige-200" | "bg-beige-300" | "bg-brown-100" | "bg-brown-200" | "bg-gold") => {
    let text = "text-white";

    if (["bg-beige-100", "bg-beige-200", "bg-beige-300"].includes(color)) {
        text = "text-brown-200";
    }
    return `${color} ${text}`;
};

const __returned__ = { apiStore, props, projects, getColor }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})